import React, { Fragment, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { toast } from "react-toastify";
import { useAuth0 } from "@auth0/auth0-react";

import PageHeaderRowSearch from "../shared/page-header-row-search";
import CateringTagsList from "./tags-list";
import CateringCatalog from "./catalog";

const CateringConfiguration = () => {
  const history = useHistory();
  const { user } = useAuth0();

  const userRoles = user && user["https://new.evojets.com/roles"];
  const isSuperAdmin =
    userRoles.some((role) => "Super Admin" === role);

  useEffect(() => {
    if (!isSuperAdmin) {
      toast.error("You do not have permission to view this page.");
      history.push("/");
    }
  }, [isSuperAdmin, history]);

  useEffect(() => {
    document.title = "Catering - Configuration | evoJets HQ";
  }, []);

  return (
    <Fragment>
      <PageHeaderRowSearch
        h1="Catering - Configuration"
        breadcrumbs={[{ link: "/catering-configuration", label: "Catering - Configuration" }]}
        extraClasses="page-header-two-columns-l1"
      />

      <Grid id="catering-configuration" container spacing={2}>
        <Grid item sm={12} lg={6}>
          <CateringCatalog/>
        </Grid>

        <Grid item sm={12} lg={6}>
          <CateringTagsList/>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default CateringConfiguration;
